__webpack_require__.p = "/tokens-marketplace/referrals-hub/";